export const TEXT = {
  MOST_POPULAR: {id: 'account_currentLK.subscribing.catchPhrase'},
  MODALITY_MONTHLY_TITLE: {id: 'account_currentLK.subscribing.1month'},
  MODALITY_MONTHLY_DESC: {id: 'myLK.subscription.monthly_subtext'},
  MODALITY_BIMONTHLY_TITLE: {id: 'account_currentLK.subscribing.2month'},
  MODALITY_BIMONTHLY_DESC: {id: 'myLK.subscription.bimonthly_subtext'},
  MODALITY_QUARTERLY_TITLE: {id: 'account_currentLK.subscribing.3month'},
  MODALITY_QUARTERLY_DESC: {id: 'myLK.subscription.quarterly_subtext'},
  MODALITY_ONDEMAND_TITLE: {id: 'myLK.subscription.ondemand_title'},
  MODALITY_ONDEMAND_DESC: {id: 'myLK.subscription.ondemand_subtext'},
} as const;
